import { css } from "@vitality-ds/system";
export default css({
  lineHeight: 1,
  display: "inline-block",
  svg: {
    width: "1em",
    height: "1em",
    color: "currentColor",
    circle: {
      stroke: "currentColor"
    },
    ellipse: {
      stroke: "currentColor"
    },
    line: {
      stroke: "currentColor"
    },
    path: {
      stroke: "currentColor"
    },
    polygon: {
      stroke: "currentColor"
    },
    polyline: {
      stroke: "currentColor"
    },
    rect: {
      stroke: "currentColor"
    },
    // Todo: find out why icons require top margin reset
    marginTop: 0
  }
});